import * as React from "react";

const IconTrashHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 12"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M1.188 10.945c.035.583.514 1.055 1.069 1.055h5.487c.555 0 1.034-.472 1.069-1.055L9.286 3H.714l.474 7.945zM9.643.75h-2.5L6.884.207A.356.356 0 006.565 0h-3.13a.356.356 0 00-.32.207L2.858.75h-2.5A.366.366 0 000 1.125v.75c0 .207.16.375.357.375h9.286A.366.366 0 0010 1.875v-.75A.367.367 0 009.643.75z"/></svg>;
};

export default React.memo(IconTrashHover);
